import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckSquare, Square, Phone, AlertTriangle, MapPin } from 'lucide-react';
import './GuidePage.css';

export default function EmergencyChecklist() {
  const [checkedItems, setCheckedItems] = useState({});

  const toggleItem = (id) => {
    setCheckedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const categories = [
    {
      name: 'Vor der Tour vorbereiten',
      items: [
        { id: 'prep1', text: 'Notfall-Kontakte Liste erstellt (Familie, Freunde)' },
        { id: 'prep2', text: 'Route & Etappen jemandem mitgeteilt' },
        { id: 'prep3', text: 'Erwartete Ankunftszeiten kommuniziert' },
        { id: 'prep4', text: 'EHIC (Europäische Krankenversicherungskarte) dabei' },
        { id: 'prep5', text: 'Reiseversicherung abgeschlossen (inkl. Rückholung!)' },
        { id: 'prep6', text: 'Versicherungs-Hotline & Policen-Nummer notiert' },
        { id: 'prep7', text: 'Persönliche Medikamente für gesamte Dauer + 3 Tage extra' },
        { id: 'prep8', text: 'Allergien/Medikamente Notiz (Englisch!) erstellt' }
      ]
    },
    {
      name: 'Notfall-Nummern (Handy + ausgedruckt!)',
      items: [
        { id: 'num1', text: 'UK Notruf: 999 (Polizei, Feuerwehr, Rettung)' },
        { id: 'num2', text: 'NHS (Gesundheit nicht-lebensbedrohlich): 111' },
        { id: 'num3', text: 'Bergrettung: 999 dann "Mountain Rescue" sagen' },
        { id: 'num4', text: 'Eigene Reiseversicherung Hotline' },
        { id: 'num5', text: 'Deutsche Botschaft Edinburgh: +44 131 337 2323' },
        { id: 'num6', text: 'Kreditkarten-Sperrhotline (international)' },
        { id: 'num7', text: 'Notfall-Kontakt Familie/Freunde' }
      ]
    },
    {
      name: 'Erste Hilfe Set (dabei haben!)',
      items: [
        { id: 'med1', text: 'Pflaster (verschiedene Größen, 10+)' },
        { id: 'med2', text: 'Sterile Kompressen (3-5 Stück)' },
        { id: 'med3', text: 'Verbandsmaterial (Rolle)' },
        { id: 'med4', text: 'Desinfektionsmittel (Spray/Tücher)' },
        { id: 'med5', text: 'Schmerzmittel (Ibuprofen/Paracetamol)' },
        { id: 'med6', text: 'Blasenpflaster (Compeed o.ä.)' },
        { id: 'med7', text: 'Zeckenzange' },
        { id: 'med8', text: 'Pinzette (für Splitter)' },
        { id: 'med9', text: 'Schere' },
        { id: 'med10', text: 'Rettungsdecke (Alufolie)' },
        { id: 'med11', text: 'Antihistamin (bei Insektenstichen)' },
        { id: 'med12', text: 'Sonnencreme (SPF 30+)' }
      ]
    },
    {
      name: 'Navigation & Kommunikation',
      items: [
        { id: 'nav1', text: 'Handy voll geladen (täglich!)' },
        { id: 'nav2', text: 'Powerbank dabei (10.000+ mAh)' },
        { id: 'nav3', text: 'Offline-Karten heruntergeladen' },
        { id: 'nav4', text: 'GPS-Gerät als Backup (optional)' },
        { id: 'nav5', text: 'Spot/Garmin InReach für echte Wildnis (optional)' },
        { id: 'nav6', text: 'Papier-Karte als Backup' }
      ]
    },
    {
      name: 'Wenn du einen Unfall hast',
      items: [
        { id: 'acc1', text: 'RUHE BEWAHREN! Tief durchatmen.' },
        { id: 'acc2', text: 'Situation einschätzen: Wie schwer verletzt?' },
        { id: 'acc3', text: 'Bei schwerer Verletzung: 999 anrufen (auch ohne Signal: Emergency-Modus)' },
        { id: 'acc4', text: 'Position merken (GPS-Koordinaten, Landmarks)' },
        { id: 'acc5', text: 'Erste Hilfe: Blutung stoppen, Wunde reinigen, verbinden' },
        { id: 'acc6', text: 'Bei leichter Verletzung: Zur nächsten Ortschaft fahren' },
        { id: 'acc7', text: 'Notfall-Kontakt informieren' },
        { id: 'acc8', text: 'Versicherung kontaktieren (Dokumentation!)' }
      ]
    },
    {
      name: 'Mechanischer Notfall (Rad kaputt)',
      items: [
        { id: 'mech1', text: 'Platter Reifen: Schlauch wechseln (hast du 2 Ersatzschläuche?)' },
        { id: 'mech2', text: 'Kette gerissen: Kettenschloss oder Multi-Tool (Kettennieter)' },
        { id: 'mech3', text: 'Bremse defekt: NICHT weiterfahren! Schieben oder Hilfe holen' },
        { id: 'mech4', text: 'Schaltung defekt: In mittlerem Gang "einfrieren" & weiterfahren' },
        { id: 'mech5', text: 'Wenn nicht reparierbar: Nächsten Bike-Shop googeln (kann weit sein!)' },
        { id: 'mech6', text: 'Notlösung: Taxi rufen (Rad mitnehmen)' },
        { id: 'mech7', text: 'E-Bike defekt: Fachhändler nötig! (Elektronik = kompliziert)' }
      ]
    },
    {
      name: 'Wetternotfall (Sturm, Starkregen)',
      items: [
        { id: 'weather1', text: 'Bei Sturmwarnung (>40mph Wind): NICHT fahren!' },
        { id: 'weather2', text: 'Schutz suchen: Pub, Café, Bus-Wartehäuschen' },
        { id: 'weather3', text: 'Bei Blitz/Gewitter: Rad ablegen, von Bäumen fernhalten' },
        { id: 'weather4', text: 'Unterkühlung-Symptome kennen: Zittern, Verwirrung, Müdigkeit' },
        { id: 'weather5', text: 'Bei Unterkühlung: Nasse Kleidung AUS, trocken & warm einpacken' },
        { id: 'weather6', text: 'Hitzschlag-Symptome: Kopfschmerzen, Schwindel, kein Schwitzen mehr' },
        { id: 'weather7', text: 'Bei Hitzschlag: Schatten, Wasser trinken, Körper kühlen' }
      ]
    },
    {
      name: 'Verirrung / Orientierung verloren',
      items: [
        { id: 'lost1', text: 'STOPPEN! Nicht weitergehen/fahren wenn unsicher' },
        { id: 'lost2', text: 'GPS/Handy checken (Offline-Karte!)' },
        { id: 'lost3', text: 'Letzten bekannten Punkt finden (Kreuzung, Landmark)' },
        { id: 'lost4', text: 'Wenn kein GPS: Zurück zum letzten sicheren Punkt' },
        { id: 'lost5', text: 'Locals fragen (Farmer, andere Radfahrer)' },
        { id: 'lost6', text: 'Bei Nebel/Dunkelheit: WARTEN! Nicht riskieren' }
      ]
    },
    {
      name: 'Diebstahl / Verlust',
      items: [
        { id: 'theft1', text: 'Rad gestohlen: Polizei (999 nicht-Notfall: 101)' },
        { id: 'theft2', text: 'Rahmennummer & Fotos von Rad parat haben' },
        { id: 'theft3', text: 'Versicherung kontaktieren (Dokumentation!)' },
        { id: 'theft4', text: 'Handy verloren: Von anderem Gerät sperren lassen' },
        { id: 'theft5', text: 'Kreditkarte verloren: Sperr-Hotline anrufen' },
        { id: 'theft6', text: 'Reisepass verloren: Deutsche Botschaft Edinburgh' }
      ]
    },
    {
      name: 'Wildtiere / Gefahren',
      items: [
        { id: 'wild1', text: 'Schafe auf Straße: LANGSAM fahren, nicht erschrecken' },
        { id: 'wild2', text: 'Highland Cattle: Abstand halten (sehen gefährlich aus, sind meist friedlich)' },
        { id: 'wild3', text: 'Zecken: Nach jeder Etappe Körper absuchen!' },
        { id: 'wild4', text: 'Zeckenbiss: Mit Zeckenzange entfernen, Stelle beobachten (Rötung?)' },
        { id: 'wild5', text: 'Midges: Midge-Netz & Spray nutzen (Juni-August!)' },
        { id: 'wild6', text: 'Schlangen (Adder): Selten, Abstand halten, nicht provozieren' }
      ]
    }
  ];

  const checkedCount = Object.values(checkedItems).filter(Boolean).length;
  const totalCount = categories.reduce((sum, cat) => sum + cat.items.length, 0);

  return (
    <div className="guide-page">
      <Link to="/wissen" className="back-link"><ArrowLeft size={20} /> Zurück zum Wissen</Link>
      
      <article className="guide-content">
        <h1>🚨 Notfall-Checkliste für Schottland</h1>
        
        <div className="info-box">
          <p>
            <strong>Hoffentlich brauchst du das nie!</strong> Aber Vorbereitung rettet Leben. 
            Fortschritt: <strong>{checkedCount} / {totalCount}</strong> Punkte vorbereitet.
          </p>
        </div>

        <div className="warning-box">
          <AlertTriangle size={24} />
          <div>
            <strong>WICHTIG: In Schottlands Highlands kann Mobilfunk fehlen!</strong><br />
            Nächstes Krankenhaus kann 100km entfernt sein. Plane voraus, sei vorsichtig!
          </div>
        </div>

        <section>
          <h2><Phone size={24} /> UK Notfall-Nummern</h2>
          
          <div className="data-grid">
            <div className="data-item">
              <strong>999</strong><br />
              Polizei, Feuerwehr, Rettung<br />
              (funktioniert auch ohne Signal!)
            </div>
            <div className="data-item">
              <strong>111</strong><br />
              NHS (Gesundheit)<br />
              nicht-lebensbedrohlich
            </div>
            <div className="data-item">
              <strong>101</strong><br />
              Polizei nicht-Notfall<br />
              (z.B. Diebstahl melden)
            </div>
            <div className="data-item">
              <strong>+44 131 337 2323</strong><br />
              Deutsche Botschaft<br />
              Edinburgh
            </div>
          </div>

          <div className="pro-tip">
            <h3>💡 999 ohne Mobilfunk-Empfang</h3>
            <p>
              In UK funktioniert 999 im <strong>Emergency-Modus</strong>: Selbst wenn dein 
              Provider kein Signal hat, nutzt das Handy JEDES verfügbare Netz (auch andere 
              Provider!). Funktioniert nicht immer, aber oft genug!
            </p>
          </div>
        </section>

        {categories.map((category, idx) => (
          <section key={idx}>
            <h2>{category.name}</h2>
            <div className="checklist">
              {category.items.map(item => (
                <div 
                  key={item.id} 
                  className="check-item" 
                  onClick={() => toggleItem(item.id)}
                  style={{ 
                    cursor: 'pointer', 
                    opacity: checkedItems[item.id] ? 0.6 : 1,
                    textDecoration: checkedItems[item.id] ? 'line-through' : 'none'
                  }}
                >
                  {checkedItems[item.id] ? <CheckSquare size={20} /> : <Square size={20} />}
                  {item.text}
                </div>
              ))}
            </div>
          </section>
        ))}

        <section>
          <h2>Krankenhäuser in Highlands</h2>
          
          <div className="warning-box">
            <MapPin size={20} />
            <strong>Krankenhäuser sind rar in Highlands!</strong><br />
            Zwischen Inverness und Thurso (200km NC500) gibt es NUR kleine Praxen, 
            keine A&E (Notaufnahme)!
          </div>

          <h3>Hauptkrankenhäuser mit A&E:</h3>
          <ul>
            <li><strong>Raigmore Hospital (Inverness):</strong> Größtes, vollständige A&E</li>
            <li><strong>Caithness General Hospital (Wick):</strong> Kleine A&E</li>
            <li><strong>Belford Hospital (Fort William):</strong> A&E, Western Highlands</li>
            <li><strong>Dr Gray's Hospital (Elgin):</strong> A&E, Speyside</li>
          </ul>

          <h3>Minor Injury Units (für kleine Verletzungen):</h3>
          <ul>
            <li>Dunbar Hospital (East Lothian)</li>
            <li>Balfour Hospital (Orkney)</li>
            <li>Gilbert Bain Hospital (Lerwick, Shetland)</li>
          </ul>
        </section>

        <section>
          <h2>Was TUN bei...</h2>
          
          <h3>🩸 Starke Blutung</h3>
          <ol>
            <li><strong>999 anrufen!</strong></li>
            <li>Direkt Druck auf Wunde (sauberes Tuch/Kleidung)</li>
            <li>Wunde höher als Herz halten (falls möglich)</li>
            <li>NICHT Tourniquet (Abbinden) außer letzter Ausweg</li>
            <li>Person warm halten (Schock vermeiden)</li>
          </ol>

          <h3>🦴 Knochenbruch Verdacht</h3>
          <ol>
            <li>NICHT bewegen! (kann schlimmer machen)</li>
            <li>999 anrufen</li>
            <li>Stelle stabilisieren (z.B. mit Stöcken, Kleidung)</li>
            <li>Person warm & ruhig halten</li>
            <li>Nichts zu essen/trinken geben (falls OP nötig)</li>
          </ol>

          <h3>🥶 Unterkühlung</h3>
          <ol>
            <li>Person aus Wind/Regen bringen</li>
            <li>Nasse Kleidung AUS, trockene AN</li>
            <li>In Rettungsdecke wickeln (Alufolie)</li>
            <li>Warme Getränke (KEIN Alkohol!)</li>
            <li>Bei schwerer Unterkühlung: 999!</li>
          </ol>

          <h3>🔥 Hitzschlag</h3>
          <ol>
            <li>In Schatten, Kleidung lockern</li>
            <li>Körper kühlen (nasse Tücher auf Stirn, Nacken)</li>
            <li>Wasser trinken (langsam!)</li>
            <li>Bei Bewusstlosigkeit: 999!</li>
          </ol>
        </section>

        <section>
          <h2>Bike-Pannen-Notfall</h2>
          
          <h3>Bike-Shops in Schottland (für Notfälle)</h3>
          <div className="info-box">
            <p>
              <strong>Unsere POIs-Sektion hat 40+ Bike-Shops!</strong> Aber Realität: 
              In Highlands sind sie weit entfernt.
            </p>
          </div>

          <h4>NC500 Route (Wichtigste Shops):</h4>
          <ul>
            <li><strong>Inverness:</strong> Mehrere Shops (Square Wheels, Velocity)</li>
            <li><strong>Ullapool:</strong> KEIN Bike-Shop! (nächster = Inverness, 90km!)</li>
            <li><strong>Lochinver - Durness:</strong> KEINE Shops (200km!)</li>
            <li><strong>Thurso:</strong> Thurso Bike Shop (endlich!)</li>
          </ul>

          <div className="warning-box">
            <AlertTriangle size={20} />
            <strong>Plan B für mechanische Pannen:</strong><br />
            - Taxi rufen (akzeptieren oft Räder)<br />
            - Bus (nicht alle nehmen Räder!)<br />
            - Locals fragen (Farmer haben oft Werkzeug!)<br />
            - Im Notfall: Tour abbrechen & nach Inverness zurück
          </div>
        </section>

        <div className="pro-tip">
          <h3>🎯 Die 5 wichtigsten Notfall-Regeln</h3>
          <ol>
            <li><strong>Ruhe bewahren!</strong> Panik verschlimmert alles</li>
            <li><strong>999 im Zweifel anrufen!</strong> Lieber einmal zu viel als zu wenig</li>
            <li><strong>Jemanden informieren!</strong> Familie/Freunde sollen wissen wo du bist</li>
            <li><strong>Erste Hilfe Set IMMER dabei!</strong> Kann Leben retten</li>
            <li><strong>Vorsicht > Geschwindigkeit!</strong> Lieber langsam & sicher als schnell & verletzt</li>
          </ol>
        </div>

        <div className="info-box">
          <h4>📚 Weiterführende Guides</h4>
          <ul>
            <li><Link to="/wissen/sicherheit">🦺 Sicherheits-Guide</Link> - Ausführliche Sicherheits-Tipps</li>
            <li><Link to="/wissen/ausruestung">🎒 Ausrüstung</Link> - Erste-Hilfe-Set Details</li>
            <li><Link to="/wissen/checklist/bike">🔧 Bike-Check</Link> - Mechanische Pannen vermeiden</li>
          </ul>
        </div>

        <div className="download-section">
          <h3>📥 Checkliste als PDF speichern</h3>
          <p>Drucke die Notfall-Checkliste aus oder speichere sie als PDF!</p>
          <button className="download-btn" onClick={() => window.print()}>
            Als PDF speichern/drucken
          </button>
        </div>

        <div className="warning-box">
          <h3>⚠️ Denk daran:</h3>
          <p>
            Diese Checkliste ersetzt KEINEN Erste-Hilfe-Kurs! Wenn möglich, mache einen 
            Kurs bevor du nach Schottland fährst. Kann Leben retten - deines oder das von anderen!
          </p>
        </div>
      </article>
    </div>
  );
}
